import React from 'react';
import { render } from '@testing-library/react';
import { BodyText } from './BodyText';

describe('BodyText', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<BodyText
				className="m-x-8 m-y-4"
				data-auto-sel="automation-selector"
			>
				Lorem ipsum dolor sit amet
			</BodyText>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
